export enum SiteStatus {
  Expired = 'Expired',
  Normal = 'Normal',
  Trial = 'Trial',
  Disabled = 'Disabled',
}
